import { AABBModel } from './AABBModel';

export enum EnvironmentTypeEnum {
    anchor_bottom = 'anchor_bottom',
    anchor_top = 'anchor_top',
    moorings = 'moorings',
    table_bottom_bridge = 'table_bottom_bridge',
    table_top_bridge = 'table_top_bridge',
    control_panel_left = 'control_panel_left',
    control_panel_right = 'control_panel_right',
    control_panel_top = 'control_panel_top',
    wheel = 'wheel',
    boat = 'boat',
    phone_CC = 'phone_CC',
    TV = 'TV',
    cupboard_bottom_CC = 'cupboard_bottom_CC',
    table_top_CC = 'table_top_CC',
    cupboard_top_CC = 'cupboard_top_CC',
    corner_sofa = 'corner_sofa',
    table_bottom_CC = 'table_bottom_CC',
    coffee_table = 'coffee_table',
    reactor = 'reactor',
    table_radio_room = 'table_radio_room',
    none = 'none',
}

export class EnvironmentModel extends AABBModel {
    public visible: boolean = false;
    public key: string = '';

    public constructor(public type: EnvironmentTypeEnum = EnvironmentTypeEnum.none) {
        super();

        this.padding = [-50, 0];
        this.height = 200;
        this.width = 200;
    }
}
